{
  "version": 1,
  "asset_id": "f13dc601-5035-40e3-94ef-fe95e84957d1",
  "project_id": "8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56",
  "url": "/__l5e/assets-v1/f13dc601-5035-40e3-94ef-fe95e84957d1/Garage_door_installation.webp",
  "r2_key": "a/v1/8e4d2e04-d0e9-4cb0-997e-36f9edfa9f56/f13dc601-5035-40e3-94ef-fe95e84957d1/Garage_door_installation.webp",
  "original_filename": "Garage_door_installation.webp",
  "size": 64208,
  "content_type": "image/webp",
  "created_at": "2026-08-10T04:00:05Z"
}
